<script setup lang="ts">
import { useI18n } from "vue-i18n";

import imageSrc from "@/Assets/images/subscription/empty-sessions.svg";

const { t } = useI18n();
</script>

<template>
  <section class="empty-list">
    <img class="empty-list__img" :src="imageSrc" alt="empty sessions" />

    <p class="empty-list__title">
      {{ t("sessions_payments_records.empty_title") }}
    </p>

    <p class="empty-list__msg">
      {{ t("sessions_payments_records.empty_msg") }}
    </p>
  </section>
</template>

<style scoped lang="scss">
.empty-list {
  @include sp.padding(false, 6);

  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  height: 100%;

  &__img {
    max-width: 230px;
    margin-left: auto;
    margin-right: auto;
  }

  &__title {
    @include sp.margin(t, 6);
    @include text.general(high, m);
    @include colors.color(content, high);
  }

  &__msg {
    @include sp.margin(t, 3);
    @include text.general(low, l);
    @include colors.color(content, mid);
    @include text.modification(center);
  }
}
</style>
